import { IBeneficiary } from '../../src/components';
import { IServerAccount, IServerAccountParam, IServerBusinessLine, IServerProductTypeItem, IServerRateConfigParams, IServerRateDeatil, IUpdateServerPasswordParam, IUpdateServerPhoneParam } from '../../types/app-account/server';
import { EProxyPayType, EServerType, IBusinessAuthInfo, IServerMergeInfo, IUpdateBusinessAuth } from '../../types/common';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 账户中心 - 服务商管理数据查询
 */
export async function queryServerAccounts(param: IServerAccountParam) {
  let data = [] as IServerAccount[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IServerAccountParam;

  try {
    const { code, context, message } = await Http.post<{ data: IServerAccount[]; total: number }>(`${hostUrl}/side/server/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IServerAccount[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 账户中心 - 服务商管理 - 启用、停用
 */
export async function changeAccServerStatus(id: number, idList?: number[]) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/changeEnable`, {
      id,
      idList, 
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
/**
 * 账户中心 - 服务商管理 - 导出
 */

export async function exportServerManage(params: IServerAccountParam) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/side/server/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 账户中心 - 服务商管理 企业服务商 新增、编辑
 * @param type false: 新增  true: 修改
 */
export async function insertAccountServer(param: IServerMergeInfo, type: boolean) {

  param = JSON.parse(JSON.stringify(param)) as IServerMergeInfo;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/side/server/${!type ? 'insert' : 'update'}`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 账户中心 - 受益人信息列表
 */
export async function queryServerAccountUboList(id: number) {
  let data = [] as IBeneficiary[];

  try {
    const { code, context, message } = await Http.post<IBeneficiary[]>(`${hostUrl}/side/server/ubo/list`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IBeneficiary[];

      data = items || [] as IBeneficiary[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 企业管理 详情 - 受益人信息保存
 * @param type true 服务商 false 企业
 */
export async function saveServerAccountUboList(id: number, beneficiary: IBeneficiary[]) {
  const params = {
    serverId: id,
    serverUboList: beneficiary,
  };

  try {
    const { code, message } = await Http.post<IBeneficiary[]>(`${hostUrl}/side/server/ubo/insert`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商安全 - 修改密码
 */
export async function updateServerPassword(params: IUpdateServerPasswordParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/pay/updatePassword`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商安全  - 修改手机号
 */
export async function updateServerPhone(params: IUpdateServerPhoneParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/pay/updatePhone`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商安全  详情 - 修改手机号（无验证码版）
 */
export async function updateCurServerPhone(id: number, newPhone: string) {
  try {
    const { code, message } = await Http.post<{id: number; newPhone: string}>(`${hostUrl}/side/server/pay/updatePhone/noCode`, {
      id,
      newPhone,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商安全  详情 - 重置密码
 */
export async function resetServerPhone(id: number, verifyCode: string) {
  try {
    const { code, message } = await Http.post<{id: number; code: string }>(`${hostUrl}/side/server/pay/resetPassword`, {
      id,
      code: verifyCode, 
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商安全  详情 - 重置密码（无验证码版）
 */
export async function resetCurServerPhone(id: number) {
  try {
    const { code, message } = await Http.post<{id: number }>(`${hostUrl}/side/server/pay/resetPassword/noCode`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商管理 获取修改权限数据
 */
export async function queryBusinessServer(serverId: number) {
  let data = [] as IBusinessAuthInfo[];

  try {
    const { code, context, message } = await Http.get<IBusinessAuthInfo[]>(`${hostUrl}/iam/business/server`, { serverId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [] as IBusinessAuthInfo[];

      data = res || [] as IBusinessAuthInfo[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 代理商管理 修改权限数据
 */
export async function updateBuinessServer(params: {serverId: number; businessList: IBusinessAuthInfo[]}) {
  params = JSON.parse(JSON.stringify(params)) as {serverId: number; businessList: IBusinessAuthInfo[]};

  try {
    const { code, message } = await Http.put<{serverId: number; businessList: IBusinessAuthInfo[]}>(`${hostUrl}/iam/business/server`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商管理 批量修改权限数据
 */
export async function updateBuinessServers(params: IUpdateBusinessAuth) {
  params = JSON.parse(JSON.stringify(params)) as IUpdateBusinessAuth;

  try {
    const { code, message } = await Http.put<IUpdateBusinessAuth>(`${hostUrl}/iam/business/servers`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商详情 查询服务商自身拥有的业务权限
 * @param id 企业id/代理商id
 */
export async function queryBusinessServerSelf(id: number) {
  let data = [] as IBusinessAuthInfo[];

  try {
    const parmas = { serverId: id };
    const { code, context, message } = await Http.get<IBusinessAuthInfo[]>(`${hostUrl}/iam/business/server-self`, parmas);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [] as IBusinessAuthInfo[];

      data = res || [] as IBusinessAuthInfo[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 服务商费率配置
 * @param id 代理商id
 */
export async function queryServerRateDeatil(id: number, proxyPayType: EProxyPayType) {
  let data = {} as IServerRateDeatil;

  try {
    const { code, context, message } = await Http.post<IServerRateDeatil>(`${hostUrl}/side/server/rate/detail`, {
      id,
      proxyPayType, 
    });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IServerRateDeatil;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 费率配置
 * @param params 
 */
export async function queryServerRateConfig(params: IServerRateConfigParams) {
  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/side/server/rate/config`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商管理 - 获取当前服务商业务线
 * @param id 企业id/代理商id
 */
export async function queryServerBusinessLine(id: number) {
  let data = [] as IServerBusinessLine[];

  try {
    const { code, context, message } = await Http.post<IServerBusinessLine[]>(`${hostUrl}/side/server/product/listForServer`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [] as IServerBusinessLine[];

      data = res || [] as IServerBusinessLine[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 服务商管理 - 启用、停用
 */
export async function updateServerProductType(id: number, serverType: EServerType, productProxyType?: number[]) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/update/product`, {
      id,
      productProxyType,
      serverType,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 服务商管理 - 获取当前服务商产品业务线
 * @param id 代理商id
 */
export async function queryServerProductList(id: number) {
  let data = [] as IServerProductTypeItem[];

  try {
    const { code, context, message } = await Http.post<IServerProductTypeItem[]>(`${hostUrl}/side/server/product-info`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as IServerProductTypeItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    if ((error as Error).message) throw new Error((error as Error).message);
  }

  return data;
}
